import { render } from "./LoyaltyPointsSection.vue?vue&type=template&id=0c14696b&scoped=true"
const script = {}

import "./LoyaltyPointsSection.vue?vue&type=style&index=0&id=0c14696b&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c14696b"]])

export default __exports__